import styled from '@emotion/styled'

import { spacing } from 'main/ui'

export const CopyContainer = styled.div`
  margin-bottom: ${spacing.majorScale(4)}px;
`
